import React, { useState, useRef, useEffect } from "react";
import I18n from "i18n-js";
import { LANGUAGE_KEY, PROFILE_KEY } from "troy-portal/constants";
import { TroyLanguageSelectionModal } from "troy-portal/language-selection-modal";
import {
  INTRO_TO_FEATURE_KEY,
  LOGOUT_KEY,
  MODAL_TYPE_LANGUAGE_SELECTION,
  USER_GUIDE_KEY,
} from "../../constants";
import { getSelectedMenu, isRoleCashier } from "../../utils";
import { Button } from "@duxton-web/ui";
import { SettingsFilled, SettingsOutlined } from "@duxton-web/icons";

const SidebarSettingV2 = (props) => {
  const {
    collapsed,
    handleItemClick,
    isModalOpen,
    modalType,
    handleCloseModal,
    handleClickLanguage,
    selectedPageKey,
  } = props;
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const isModalVisible =
    isModalOpen && modalType === MODAL_TYPE_LANGUAGE_SELECTION;
  const isCashier = isRoleCashier();
  const settingMenus = [
    {
      key: PROFILE_KEY,
      title: I18n.t("troyCommon-navigation-001-004"),
      show: true,
    },
    {
      key: LANGUAGE_KEY,
      title: I18n.t("troyCommon-navigation-003-001"),
      show: true,
      testId: "btnLanguage",
    },
    {
      key: INTRO_TO_FEATURE_KEY,
      title: I18n.t("troyCommon-navigation-003-002"),
      show: !isCashier,
    },
    {
      key: USER_GUIDE_KEY,
      title: I18n.t("mex-portalonboarding-002-002-dropdown"),
      show: false,
    },
    {
      key: LOGOUT_KEY,
      title: I18n.t("troyCommon-navigation-001-006"),
      show: true,
      testId: "btnLogOut",
    },
  ];

  //only items that redirect to internal link has a selected state
  const currSelectedPageKey = selectedPageKey || getSelectedMenu();
  const isSettingSelected =
    settingMenus.findIndex((obj) => obj.key === currSelectedPageKey) > -1;

  const handleDropdownItemClicked = (key) => {
    handleItemClick({ key });
    setIsDropdownVisible(false);
  };

  const settingMenuRef = useRef();
  useEffect(() => {
    const handleOutsideClick = (e) => {
      // only focus on element other than setting menu
      if (
        settingMenuRef.current &&
        !settingMenuRef.current.contains(e.target)
      ) {
        setIsDropdownVisible(false);
      }
    };
    document.body.addEventListener("click", handleOutsideClick);
    return () => {
      document.body.removeEventListener("click", handleOutsideClick);
    };
  });
  const [menuTop, setMenuTop] = useState(0);

  /**
   *
   * @param {Event} e
   */
  const handleSettingButtonClick = (e) => {
    setMenuTop(collapsed ? e.currentTarget.getBoundingClientRect().bottom : 0);
    setIsDropdownVisible(!isDropdownVisible);
    e.stopPropagation();
  };

  const Icon =
    isSettingSelected && !isDropdownVisible ? SettingsFilled : SettingsOutlined;
  return (
    <div
      className={
        (isSettingSelected ? " selected" : "") +
        " troy-setting-dropdown-container"
      }
      data-testid={"btnSetting"}
    >
      <Button
        shape="circle"
        icon={<Icon style={{ fontSize: 20 }} />}
        onClick={handleSettingButtonClick}
      />
      <div
        className={[
          "sidebar-setting-menu",
          isDropdownVisible ? "sidebar-setting-menu--show" : "",
        ].join(" ")}
        ref={settingMenuRef}
        style={{ bottom: `calc(100% - ${menuTop}px)` }}
      >
        {settingMenus.map((menu) => {
          if (menu.show) {
            return (
              <div
                className={
                  "troy-setting-dropdown-items " +
                  (menu.key === LOGOUT_KEY
                    ? "troy-setting-dropdown-item-logout"
                    : "troy-setting-dropdown-item") +
                  (currSelectedPageKey === menu.key
                    ? " troy-setting-dropdown-item-selected"
                    : "")
                }
                key={menu.key}
                onClick={() => handleDropdownItemClicked(menu.key)}
              >
                <span data-testid={menu.testId}>{menu.title}</span>
              </div>
            );
          }
        })}
      </div>
      <TroyLanguageSelectionModal
        visible={isModalVisible}
        onCancel={() => handleCloseModal(MODAL_TYPE_LANGUAGE_SELECTION)}
        {...{ handleClickLanguage }}
      />
    </div>
  );
};

export default SidebarSettingV2;
